<ng-container *transloco="let t">
  <div class="card p-mb-4">
    <h1>{{ t('orderconfirmation.topline') }}</h1>
    <div class="p-grid p-mt-4 p-mb-4">
      <div class="p-col-fixed" style="width: 60px;">
        <i class="pi pi-check-circle"></i>
      </div>
      <div class="p-col">
        <p [innerHtml]="t('orderconfirmation.message', { id: data?.id })"></p>
      </div>
    </div>
    <p><button pButton (click)="gotoOrderform()" [label]="t('orderconfirmation.buttontext')" class="p-button-success"></button></p>
  </div>
</ng-container>
